import {Component, ViewEncapsulation} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {MarketingPopupComponent} from './modules/web/components/marketing-popup/marketing-popup.component';
import {RegistryService} from './modules/web/services/registry.service';

declare let gtag: Function;

// declare let fbq:Function;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    encapsulation: ViewEncapsulation.None

})
export class AppComponent {
    title = 'AdCommerce';

    admin: Array<{ title: String, subtitle: String, path: String, order: String, class: String, icon: String }> = [];


    constructor(private router: Router, private registry: RegistryService) {

        router.events.subscribe((y: NavigationEnd) => {
            if (y instanceof NavigationEnd) {
               // gtag('config', 'UA-145145696-1', {'page_path': y.url});
                // fbq('track', 'PageView');
            }
        });






    }




}
